export default "__VITE_ASSET__l7t6cdwZ__"